import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import '../../styles/chapter2/chapter-two-timeline.scss';

import TimelineInnerNavi from '../timelineInnerNavi';
import Iconset from '../icons';

function InactiveTimeline(props){
	let markerNumber = 3 + props.number;
	let questionNumber = 1 + props.number;
	return (<button className={"timeline-track-marker inactive marker-2-" + markerNumber } data-name={2} data-question={props.number}></button>);
{/*	<span className="tool-tip" data-name={2} data-question={props.number}>#question {questionNumber}</span>*/}
}

function ActiveTimeline(props){
	let markerNumber = 3 + props.number;
	let questionNumber = 1 + props.number;
	return (<button className={"timeline-track-marker marker-2-" + markerNumber } data-name={2} data-question={props.number} onClick={props.goToSpecificQuestion}>
			<span className="tool-tip" data-name={2} data-question={props.number}>#question {questionNumber}</span>
		</button>);
}

class Timeline extends React.Component{

	constructor(props){
		super(props);

	}
	
	togglePlay(){
		this.playButton.blur();
		if(this.props.isPlaying){
			this.props.pause();
		}else{
			this.props.play();
		}
	}

	goToOutro(){
		browserHistory.push(_assets.root + '/outro');
	}

	setNotSelectedQuestions(){
		let offset = this.props.selectedQuestions.length;
		var arr = []

		for(var i=0;i<5-offset;i++){
			arr.push( <InactiveTimeline number={i + offset} />);
		}
		return arr;
	}

	calculateTimeLineWidth(){
		var width = 0;

		switch(this.props.currentInnerChapter){
		//intro video
			case 0:
				width = this.props.currentVideoTimePercentage * .1;
			break;
		//fast video
			case 1:
				width = 10 + (this.props.currentVideoTimePercentage * .15)
			break;
		//quiz
			case 2:
			var offset = 1;

				if(this.props.showIntro){
					width = 25;
				}else{
					if(this.props.question === 6){
						width = 100;
					}else{
						if(this.props.timeforInterview && this.props.question === 1 && this.props.currentVideoTimePercentage != 0){
							offset = 2;
						}

						width = 25 + (this.props.currentVideoTimePercentage * .15) + ((this.props.question - offset) * 15);
					}
				}

			break;
		}

		return width;
	}

	render(){
		
		let timelineTrackStyle = {
			width : this.calculateTimeLineWidth() +'%'
		}
		let publicChapter = this.props.currentInnerChapter ;
		
		const notSelectedQuestions = this.setNotSelectedQuestions();

		return (
			<div className="flex-box timeline-holder">
				<div className="timeline-inner">
					<button ref={(playButton)=>{this.playButton = playButton}}className={"play-button isPlaying-"+ this.props.isPlaying} onClick={()=>this.togglePlay()}>
						{ this.props.isPlaying && 
								<Iconset.pause/>
							}{ !this.props.isPlaying && 
									<Iconset.play/>
								}</button>
					{/*<div className="currentTime helper">{this.props.innerChapter} | {this.props.currentInnerChapterTime}</div>*/}
					<TimelineInnerNavi />
					<div className="timeline-track">
						<div className="timeline-track-slider" style={timelineTrackStyle}></div>
						<div className={"timeline-track-marker-holder active-marker-" + publicChapter}>
							<button className="timeline-track-marker marker-2-1" data-name="0" onClick={(event)=>this.props.goToInnerChapter(event)}>
								<span className="tool-tip" data-name="0">#intro</span>
							</button>
							<button className="timeline-track-marker marker-2-2" data-name="1" onClick={(event)=>this.props.goToInnerChapter(event)}>
								<span className="tool-tip" data-name="1">#photomorph</span>
							</button>


								{/* Not set questions */}
								{this.props.selectedQuestions.map(function(question, index){
									return (<ActiveTimeline number={index} goToSpecificQuestion={(event)=>this.props.goToSpecificQuestion(event)}/>);
								}.bind(this))}

								{/* Not set questions */}
								{notSelectedQuestions.map(function(q, index){
									return (q);
								}.bind(this))}

							<div className={"timeline-track-marker-triangle pw-indicator-"+this.props.showSlideshowLogin}></div>
							<button className="timeline-track-marker marker-2-8" data-name="3" onClick={this.goToOutro}>
								<span className="tool-tip" data-name="3">#outro</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			)
	}

}


export default Timeline;


// WEBPACK FOOTER //
// ./src/scripts/chapter2/chapter_two_timeline.js